import {
	startCheckIsAnyFieldToHighlight,
	setFieldToHighlight,
	clearFieldToHighlight,
	setFieldToHighlightToDefault,
} from './slices'

export const startCheckComplaintMandatoryFields = () => async (dispatch) => {
	try {
		dispatch(startCheckIsAnyFieldToHighlight({}))
	} catch (error) {
		console.error(error, 'returnado specific')
	}
}

export const markFieldToHighlight = (payload) => async (dispatch) => {
	try {
		dispatch(setFieldToHighlight(payload))
	} catch (error) {
		console.error(error, 'returnado specific')
	}
}

export const unmarkFieldToHighlight = (payload) => async (dispatch) => {
	try {
		dispatch(clearFieldToHighlight(payload))
	} catch (error) {
		console.error(error, 'returnado specific')
	}
}

export const setFieldToHighlightInToDefault = (payload) => async (dispatch) => {
	try {
		dispatch(setFieldToHighlightToDefault(payload))
	} catch (error) {
		console.error(error, 'returnado specific')
	}
}
